export default "__VITE_ASSET__BSm4lkjn__"